// eslint-disable-next-line no-shadow
enum EDataSourceActionMethods {
    POST = 'POST',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
}

export default EDataSourceActionMethods
